<mat-icon class="balloon__close-icon mat-icon-size-xs"
  svgIcon="ds-ic-close"
  (click)="closeBalloon()"></mat-icon>
<ng-container *ngTemplateOutlet="contentTemplate; context: { $implicit: balloon }"></ng-container>
<div *ngIf="showSpike"
  class="balloon__spike"
  [ngClass]="spikePositionClass"></div>
